const Prescription = (props: any) => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="48" height="48" fill="white" fill-opacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 6H24H28H30L40 16V19.5V24V42H8V6Z"
      stroke="#000000"
      strokeWidth="4"
      strokeLinejoin="round"
    />
    <path
      d="M27.0244 6V18.0818H39.9996"
      stroke="#000000"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 30H26"
      stroke="#000000"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M20 24V36"
      stroke="#000000"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export default Prescription;
